import parseToNational from './parseToNational';
import checkPhoneRequired from './checkPhoneRequired';
import showPhoneField from './showPhoneField';
import checkPhoneWithWhiteSpace from '@/utils/phoneUtils/checkPhoneWtithWhiteSpace';

const PhoneUtils = {
  parseToNational,
  checkPhoneRequired,
  showPhoneField,
  checkPhoneWithWhiteSpace,
};

export default PhoneUtils;
